import { Injectable } from '@angular/core';
import { Wood } from '../interfaces/wood';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WoodCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/settings/woods/' ;
  }

  // Create Wood
  add(record: Wood) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Wood Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Woods List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Wood Object
  update(record: Wood) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Wood>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Wood Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}
